import { render, staticRenderFns } from "./GiftDetailOut.vue?vue&type=template&id=3c7f3513&scoped=true&"
import script from "./GiftDetailOut.vue?vue&type=script&lang=js&"
export * from "./GiftDetailOut.vue?vue&type=script&lang=js&"
import style0 from "./GiftDetailOut.vue?vue&type=style&index=0&id=3c7f3513&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f3513",
  null
  
)

export default component.exports